import Vue from 'vue';
import VueRouter from 'vue-router';
import JoinMeeting from '@/components/JoinMeeting.vue'

Vue.use(VueRouter);

const routes = [
    {
        path: '/j',
        name: 'JoinMeeting',
        component: JoinMeeting,
        meta: {
            title: '加入会议', affix: true
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router;